import { memo, useMemo } from 'react'
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model'
import { AgGridReact, AgGridReactProps } from '@ag-grid-community/react'
import {
  ColDef,
  GetRowIdParams,
  GetRowIdFunc,
  // GridReadyEvent,
  ColumnMovedEvent,
} from '@ag-grid-community/core'
import '@ag-grid-community/styles/ag-grid.css'
import '@ag-grid-community/styles/ag-theme-quartz.css'
import './style.css'
import { updateTableCols } from 'utils/api/userManagement'
// import { useLocation } from 'react-router-dom'
import { ActiveColumnKey } from 'types/dataTable'

// The default column configurations
const defaultColDef: ColDef = {
  flex: 1,
  minWidth: 100,
  filter: false,
  sortable: false,
}

interface DataTableProps
  extends Omit<AgGridReactProps, 'columnDefs' | 'defaultColDef' | 'rowData'> {
  columns: ColDef[]
  // null shows AG Grid's loading overlay
  rows: any[] | null
  identifier?: string
  activeColumnsKey?: ActiveColumnKey
  activeColumns?: string[]
}

const DataTable = ({
  columns: initialColumns,
  rows,
  identifier,
  activeColumnsKey,
  activeColumns,
  ...props
}: DataTableProps) => {
  // const { search } = useLocation()

  // Initialize with initial columns
  const columns = useMemo(() => {
    if (activeColumns && activeColumns.length > 0) {
      const cols = initialColumns.filter((col) =>
        activeColumns.includes(col.field as string),
      )

      if (cols.length <= 0) return initialColumns

      return activeColumns
        .map((col) => cols.find((colDef) => colDef?.field === col))
        .filter(Boolean) as ColDef[] // Assert the type here
    }

    return initialColumns
  }, [initialColumns, activeColumns])

  // sets the row unique id for getting data using grid api
  const getRowId = useMemo<GetRowIdFunc>(() => {
    return (params: GetRowIdParams) => identifier && params.data[identifier]
  }, [])

  // to store the column state when column is moved
  const onColumnMoved = async (params: ColumnMovedEvent) => {
    if (activeColumnsKey) {
      try {
        const columnState = params.api.getColumnState().map((col) => col.colId)
        await updateTableCols({ [activeColumnsKey]: columnState })
      } catch (error) {
        // empty
      }
    }
  }

  return (
    <>
      {/* Data Table */}
      <div className="ag-theme-quartz h-full max-h-[479px] w-full">
        <AgGridReact
          key={JSON.stringify({ rows })}
          //* Column
          columnDefs={columns}
          defaultColDef={defaultColDef}
          // onColumnMoved={onColumnMoved}
          // @ts-expect-error: this event exist by its type don't
          onDragStopped={onColumnMoved}
          // if set to false will remove column when dragged outside
          suppressDragLeaveHidesColumns={true}
          //* text selection
          enableCellTextSelection
          ensureDomOrder
          //* row
          rowData={rows}
          animateRows={true}
          getRowId={getRowId}
          //* modules
          modules={[ClientSideRowModelModule]}
          {...props}
        />
      </div>
    </>
  )
}

export default memo(DataTable)
